var map = {
	"./badge-first-collectible-active.svg": 3,
	"./badge-first-collectible-done.svg": 52765,
	"./badge-first-collectible.svg": 36254,
	"./badge-first-transaction-active.svg": 77836,
	"./badge-first-transaction-done.svg": 90061,
	"./badge-first-transaction.svg": 22940,
	"./badge-topped-wallet-active.svg": 24474,
	"./badge-topped-wallet-done.svg": 85940,
	"./badge-topped-wallet.svg": 42374,
	"./badge-wallet-created-active.svg": 56289,
	"./badge-wallet-created.svg": 19529,
	"./banxa-logo-white.svg": 11533,
	"./banxa-logo.svg": 89826,
	"./crypto-logo-white.png": 64955,
	"./crypto-logo.png": 18097,
	"./dark.svg": 75315,
	"./exclamation-triangle.png": 46991,
	"./goto-link.svg": 85438,
	"./home-illustration.svg": 10020,
	"./learn-more.svg": 57192,
	"./light.svg": 12934,
	"./link-account-success.svg": 53044,
	"./link-account.svg": 22821,
	"./login-bg-1.svg": 2213,
	"./login-bg-2.svg": 95325,
	"./login-bg-3.svg": 77597,
	"./login-bg-binance-1.svg": 38528,
	"./login-bg-dark-1.svg": 22886,
	"./login-bg-dark-2.svg": 15393,
	"./login-bg-dark-3.svg": 2283,
	"./login-bg-dark-binance-1.svg": 50129,
	"./login-bg-dark.jpg": 7354,
	"./login-bg-new-1.svg": 26621,
	"./login-bg-new-2.svg": 38752,
	"./login-bg-new-3.svg": 95413,
	"./login-bg-new-dark-1.svg": 27848,
	"./login-bg-new-dark-2.svg": 51428,
	"./login-bg-new-dark-3.svg": 61212,
	"./login-bg.jpg": 85338,
	"./login-verifiers-dark.gif": 46772,
	"./login-verifiers-light.gif": 26191,
	"./login.png": 95567,
	"./loginWhite.png": 27027,
	"./loginwithgoogle.png": 35343,
	"./logo.png": 74427,
	"./logo2x.png": 37775,
	"./logout-dark.svg": 36433,
	"./logout.svg": 16301,
	"./mercuryo-logo-white.svg": 99909,
	"./mercuryo-logo.svg": 29912,
	"./miime-logo-dark.svg": 18400,
	"./miime-logo.svg": 18514,
	"./moonpay-logo-white.svg": 90383,
	"./moonpay-logo.svg": 91628,
	"./ob-access.svg": 43681,
	"./ob-add-2fa-created-dark.svg": 85450,
	"./ob-add-2fa-created.svg": 22580,
	"./ob-add-2fa-dark.svg": 70482,
	"./ob-add-2fa.svg": 61158,
	"./ob-browser.svg": 87734,
	"./ob-password.svg": 74747,
	"./ob-secure.svg": 39290,
	"./ob-self-custodial.svg": 13537,
	"./ob-social.svg": 24681,
	"./ob-tkey.svg": 12441,
	"./ob-verification-done.svg": 12614,
	"./ob-verification-methods.svg": 42566,
	"./ob-verification.svg": 85508,
	"./onboarding-1-1.svg": 16385,
	"./onboarding-1-2.svg": 45177,
	"./onboarding-2.svg": 91689,
	"./onboarding-3.svg": 95228,
	"./opensea-logo-dark.svg": 48288,
	"./opensea-logo.svg": 83059,
	"./oval-google.svg": 2794,
	"./passwordless.svg": 14800,
	"./provider-mercuryo.svg": 59607,
	"./provider-moonpay.svg": 82456,
	"./provider-rampnetwork.svg": 95039,
	"./provider-simplex.svg": 3609,
	"./provider-transak.svg": 87307,
	"./provider-wyre.svg": 41103,
	"./provider-xanpool.svg": 6337,
	"./rampnetwork-logo-white.svg": 22608,
	"./rampnetwork-logo.svg": 91720,
	"./security.svg": 30672,
	"./simplex-logo-white.png": 97058,
	"./simplex-logo.png": 15457,
	"./status-fail.svg": 73967,
	"./status-pending.svg": 88408,
	"./status-success.svg": 32965,
	"./torus-logo-blue.svg": 12845,
	"./torus-logo-white-new.svg": 11309,
	"./torus-logo-white.svg": 76627,
	"./transak-logo-white.svg": 89852,
	"./transak-logo.svg": 7300,
	"./wallet-connect-dapps.png": 25647,
	"./walletGuide.svg": 38981,
	"./web3auth-dark.svg": 36747,
	"./web3auth-logo.svg": 44982,
	"./web3auth.svg": 19141,
	"./wyre-logo-white.svg": 48407,
	"./wyre-logo.svg": 88232,
	"./xanpool-logo-white.svg": 12693,
	"./xanpool-logo.svg": 35807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;